// extracted by mini-css-extract-plugin
module.exports = {"item":"ArticleItemList_item__3shiT","sending":"ArticleItemList_sending__3h6g_"};